module.exports = __webpack_public_path__ + "b71c3114910ad3e137ce27ec04732a40.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Header/img/anim.gif
 ** module id = 467
 ** module chunks = 0
 **/